/*
This is Hook is used to Decrypt the Record ID in the URL
and if the ID is not decrypted it will redirect to the home page
params => Id => encrypted ID
*/
import React, { useEffect, useState } from "react"
import { decryptId } from "utils"
import useCustomNavigate from "./routerHooks/useCustomNavigate"

const useDecryptId = (encryptedId) => {
  const [decryptedId, setDecryptedId] = useState("")
  const { navigateToReplace } = useCustomNavigate()
  useEffect(() => {
    if (encryptedId) {
      try {
        const result = decryptId(encryptedId)
        if (result) {
          setDecryptedId(+result)
        }
      } catch (error) {
        navigateToReplace("/")
        return
      }
    }
  }, [encryptedId])

  return { decryptedId }
}

export default useDecryptId
